<form>
  <div class="card">
    <div>
      <h3 class="card-title">{{ 'info' | translate }}</h3>
    </div>
    <div class="table-responsive">
      <table class="table m-0">
        <tbody>
          @if (order.reservationNumber) {
            <tr>
              <th class="card-subheading">{{ 'reservation' | translate }}</th>
              <td class="text-end no-hover">{{ order.reservationNumber }}</td>
            </tr>
          }
          <tr>
            <th class="card-subheading">{{ 'externalReference' | translate }}</th>
            @if (!readonly) {
              <td class="text-end no-hover">
                <form-row-input
                  [label]="null"
                  [icon]="null"
                  [noMarginBottom]="true"
                  [model]="order.externalReference"
                  (modelChange)="selectedExternalReference($event)"
                  [dataCyAttribute]="'order-externalReference'"
                >
                </form-row-input>
              </td>
            }
            @if (readonly) {
              <td class="text-end no-hover" data-cy="order-externalReference">{{ order.externalReference }}</td>
            }
          </tr>
          @if (order.billNumber && order.billNumber > 0) {
            <tr>
              <th class="text-nowrap card-subheading">{{ 'bill' | translate }}</th>
              <td class="text-end no-hover" data-cy="'order-billNumber'">{{ order.billNumber }}</td>
            </tr>
          }
          <tr>
            <th class="card-subheading">{{ 'checkout' | translate }}</th>
            <td class="text-end no-hover" data-cy="order-checkout">
              {{ order.checkout ? order.checkout.name : '' }}
            </td>
          </tr>
          <tr>
            <th class="card-subheading">{{ 'currency' | translate }}</th>
            @if (canCreateOrEdit && order.status.id !== 'bill') {
              <td class="text-end no-hover flex-gap-5 justify-content-end">
                <form-row-select
                  [label]="null"
                  [icon]="null"
                  [noMarginBottom]="true"
                  [options]="currencies"
                  [bindToObject]="true"
                  [model]="order.currency"
                  (modelChange)="selectedCurrency($event)"
                  [dataCyAttribute]="'order-currency'"
                ></form-row-select>
                <btn
                  [title]="'recalculate' | translate"
                  [icon]="'far-sync'"
                  [classes]="['btn-third', 'btn-sm']"
                  (onEvent)="onRecalculatedPricesByPriceLevel()"
                >
                </btn>
              </td>
            }
            @if (!canCreateOrEdit || order.status.id === 'bill') {
              <td class="text-end no-hover">
                {{ order.currency?.name }}
              </td>
            }
          </tr>
          <tr>
            <th class="card-subheading">{{ 'dateCreated' | translate }}</th>
            <td class="text-end no-hover">
              <div>
                {{ order.dateCreated | strToDate | date: 'dd.MM.yyyy HH:mm' }}
              </div>
            </td>
          </tr>
          @if (order.status.id === 'bill' && (order.dateBill?.length > 0 || canCreateOrEdit)) {
            <tr>
              <th class="card-subheading">{{ 'dateBill' | translate }}</th>
              @if (!canCreateOrEdit) {
                <td class="text-end no-hover">
                  {{ order.dateBill | strToDate | date: 'dd.MM.yyyy' }}
                </td>
              }
              @if (canCreateOrEdit) {
                <td class="text-end no-hover">
                  <form-row-input
                    [icon]="'fa-clock'"
                    [model]="order.dateBill | fmtDate: 'yyyy-MM-dd'"
                    (modelChange)="selectedDateBill($event)"
                    [inputType]="'Date'"
                  ></form-row-input>
                </td>
              }
            </tr>
          }
          @if (order.vs > 0) {
            <tr>
              <th class="card-subheading">{{ 'vs' | translate }}</th>
              <td class="text-end no-hover">{{ order.vs ? order.vs : '' }}</td>
            </tr>
          }
          @if (order.dateTax?.length > 0 || canCreateOrEdit) {
            <tr>
              <th class="card-subheading">
                {{ 'duzp' | translate }}
              </th>
              <td class="text-end no-hover">
                @if (canCreateOrEdit) {
                  <form-row-input
                    [icon]="'fa-clock'"
                    [model]="order.dateTax | fmtDate: 'yyyy-MM-dd'"
                    (modelChange)="selectedDateTax($event)"
                    [inputType]="'Date'"
                  ></form-row-input>
                }
                @if (!canCreateOrEdit) {
                  <div>
                    {{ order.dateTax | strToDate | date: 'dd.MM.yyyy' }}
                  </div>
                }
              </td>
            </tr>
          }
          @if (order.dateDue?.length > 0 || canCreateOrEdit) {
            <tr>
              <th class="card-subheading">
                {{ 'dateDue' | translate }}
              </th>
              <td class="text-end no-hover">
                @if (canCreateOrEdit) {
                  <form-row-input
                    [icon]="'fa-clock'"
                    [model]="order.dateDue | fmtDate: 'yyyy-MM-dd'"
                    (modelChange)="selectedDateDue($event)"
                    [inputType]="'Date'"
                  ></form-row-input>
                }
                @if (!canCreateOrEdit) {
                  <div>
                    {{ order.dateDue | strToDate | date: 'dd.MM.yyyy' }}
                  </div>
                }
              </td>
            </tr>
          }
          <tr>
            <th class="card-subheading">{{ 'createdBy' | translate }}</th>
            <td class="text-end no-hover">
              @if (order.createdBy) {
                <a class="link" [routerLink]="['/user', order.createdBy.id]">{{
                  order.createdBy && order.createdBy
                    ? order.createdBy.firstName + ' ' + order.createdBy.lastName + ' (' + order.createdBy.email + ')'
                    : ''
                }}</a>
              }
            </td>
          </tr>
          @if (order.externalId) {
            <tr>
              <th class="card-subheading">{{ 'externalId' | translate }}</th>
              <td class="text-end no-hover">
                {{ order.externalId }}
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</form>
